import $http from '../../shared/http';
import { resolveWellKnownEndpoint } from './well_known';

export const service_types = {
  namespaced: true,
  state: () => {
    return {
      serviceTypesForSelect: null,
      serviceTypesByOrganisationForSelect: null,
      serviceTypesByDateSelect: null,
      serviceTypeData: null,
      currentServiceServiceType: null,
    };
  },
  getters: {
    getServiceTypesForSelect: (state) => state.serviceTypesForSelect,
    getServiceTypesByOrganisationForSelect: (state) => state.serviceTypesByOrganisationForSelect,
    getServiceTypeData: (state) => state.serviceTypeData,
    getCurrentServiceServiceType: (state) => state.currentServiceServiceType,
    isServiceTypesWithoutTimesExist: (state) => state.serviceTypesWithoutTimesExist,
  },
  mutations: {
    setServiceTypesForSelect: (state, payload) => (state.serviceTypesForSelect = payload),
    SET_SERVICE_TYPES_WITHOUT_TIMES_EXIST: (state, payload) =>
      (state.serviceTypesWithoutTimesExist = payload),
    setServiceTypesByOrganisationForSelect: (state, payload) =>
      (state.serviceTypesByOrganisationForSelect = payload),
    initialiseServiceTypeForm: (state) => {
      state.serviceTypesForSelect = null;
      state.serviceTypesByDateSelect = null;
    },
    setServiceTypeData: (state, payload) => {
      state.serviceTypeData = payload;
      state.currentServiceServiceType = payload;
    },
  },
  actions: {
    async loadServiceTypesForSelect({ commit }, payload) {
      const { churchId, filter } = payload;
      return $http('v2')
        .get(`organisations/${churchId}/service_types/select`, {
          params: { ...filter },
          canBeImpersonated: true,
        })
        .then((response) => {
          commit('setServiceTypesForSelect', response.data.data);
          return response;
        });
    },

    async loadServiceTypesByOrganisationForSelect({ commit }, payload) {
      return new Promise(async (resolve) => {
        let org, filter, churchId;
        if (payload) {
          org = payload.org;
          filter = payload.filter;
          churchId = payload.churchId;
        }
        commit('setServiceTypesByOrganisationForSelect', null);
        await $http()
          .get(`/organisations/${churchId}/serviceTypesByOrganisationForSelect`, {
            params: filter
              ? {
                  organisation_id: org ? org : null,
                  ...filter,
                }
              : {
                  organisation_id: org ? org : null,
                },
          })
          .then((response) => {
            commit('setServiceTypesByOrganisationForSelect', response.data.data);
            resolve(response);
          })
          .catch((error) => {
            return error;
          });
      });
    },

    async LOAD_SERVICE_TYPE_DATA({ commit }, { churchId, serviceTypeId }) {
      const url = resolveWellKnownEndpoint('admin_api.v2.organisations.service_types.show', {
        organisation_id: churchId,
        id: serviceTypeId,
      })?.url;

      if (!url) {
        return;
      }

      return $http('v2')
        .get(`${url}`)
        .then(async (response) => {
          commit('setServiceTypeData', response.data.data);
          return response;
        });
    },

    async CREATE_SERVICE_TYPE(ctx, { form, churchId }) {
      return $http('v2').post(`organisations/${churchId}/service_types`, form, {
        headers: { 'X-Is-Notifiable': 'On' },
      });
    },

    async EDIT_SERVICE_TYPE(ctx, { form, serviceTypeId, churchId }) {
      return $http('v2').put(`organisations/${churchId}/service_types/${serviceTypeId}`, form, {
        headers: { 'X-Is-Notifiable': 'On' },
      });
    },

    async DELETE_SERVICE_TYPE(ctx, { serviceTypeId, churchId }) {
      return $http('v2').delete(`organisations/${churchId}/service_types/${serviceTypeId}`, {
        notifiable: true,
      });
    },

    async CHECK_FOR_SERVICE_TYPES_WITHOUT_TIMES({ commit }) {
      return new Promise(async () => {
        commit('SET_SERVICE_TYPES_WITHOUT_TIMES_EXIST', false);
        await $http()
          .get(`/service-types/no-times`)
          .then(async (response) => {
            commit('SET_SERVICE_TYPES_WITHOUT_TIMES_EXIST', response.data.data);
            return response;
          });
      });
    },
  },
};
